<template>
  <div class="business-school">
    <div class="expert-team">
      <div class="expert-content">
        <div class="title">{{ expertTitle }}</div>
        <div class="describe">{{ expertDescribe }}</div>
        <div class="expert-wrap" v-if="expertList.length != 0">
          <div
            v-for="(item, index) in expertList"
            :key="index"
            class="expert-item"
            @click="viewDetails(index)"
          >
            <div class="expert-portrait">
              <img :src="item.portrait" alt="" class="portrait-img"/>
            </div>
            <div class="expert-txt">
              <div class="expert-name">{{ item.name }}</div>
              <div class="expert-position">{{ item.position }}</div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
          background
          layout="prev, pager, next"
          :page-size="page.pageSize"
          :total="page.total"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
          />
        </div>
        <div class="expert-wrap">
          <transition name="expert-transition">
            <div v-if="expertList.length != 0" :key="expertIndex" class="expert">
              <div class="expert-portrait">
                <img :src="expertList[expertIndex].portrait" alt="" />
              </div>
              <div class="expert-introduce">
                <swiper class="swiper" :options="swiperOption">
                  <swiper-slide class="text">
                    <div class="expert-name">
                      {{ expertList[expertIndex].name }}
                    </div>
                    <div class="expert-position">
                      {{ expertList[expertIndex].position }}
                    </div>
                    <div class="expert-title-list" v-html="expertList[expertIndex].title">
                    </div>
                  </swiper-slide>
                  <div slot="scrollbar" class="swiper-scrollbar"></div>
                </swiper>
              </div>
            </div>
          </transition>
          <div class="switch-button">
            <div class="button prev-button" @click="prev">
              <img
                :src="require('@/assets/about/business/prev.png')"
                alt=""
                class="button-icon"
                :class="{'noNext': expertIndex == 0}"
              />
            </div>
            <div class="button nest-button" @click="nest">
              <img
                :src="require('@/assets/about/business/nest.png')"
                alt=""
                class="button-icon"
                :class="{'noNext': expertIndex == expertList.length - 1}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="personnel" v-show="false">
      <div class="content">
        <div class="title">{{ personnelTitle }}</div>
        <div class="describe">{{ personnelDescribe }}</div>
        <div class="content-wrap">
          <div class="wrap-left">
            <transition name="wrap-transition">
              <div v-if="personnelList.length != 0" :key="personnelIndex">
                <div class="wrap-item" v-html="personnelList[personnelIndex]">
                  <!-- <img :src="require('@/assets/about/business/wrap.png')" alt="" class="img" /> -->
                </div>
              </div>
            </transition>
          </div>
          <div class="wrap-right">
            <div class="major-list">
              <div
                v-for="(item, index) in majorList"
                :key="index"
                class="major-item"
              >
                <div class="major-icon">
                  <img :src="item.icon" alt="" class="icon" />
                </div>
                <div class="major-text">{{ item.text }}</div>
              </div>
            </div>
            <div class="switch-wrap">
              <div class="button prev" @click="personnelPrev"></div>
              <div class="button nest" @click="personnelNest"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="research-wrap">
      <div class="title">人才考证</div>
      <div class="describe">华跃优才商学院与多家正规考证机构联动合作，能提供学历提升、职业技能考证等渠道，让你快速提升自身实力。</div>
      <div class="research-content">
        <img :src="require('@/assets/about/business/grade.png')" alt="" class="content-top" />
        <div class="content-bottom">
          <div
            v-for="(item, index) in typeList"
            :key="index"
            class="type-list"
          >
            <div
              v-for="(typeItem, typeIndex) in item.part"
              :key="typeIndex"
              class="type-item"
            >
              <img :src="typeItem.icon" alt="" class="type-icon" />
              <div class="type-text">{{ typeItem.text }}</div>
            </div>
            <div class="type-item more">
              <img :src="require('@/assets/about/business/icon/more-icon.png')" alt="" class="type-icon" />
              <div class="type-text">更多</div>
              <div class="more-wrap">
                <div class="more-top">
                  <div class="top-title">其他职业技能</div>
                </div>
                <div class="more-content">
                  <div
                    v-for="(moreItem, moreIndex) in item.more"
                    :key="moreIndex"
                    class="more-item"
                  >
                    <svg
                      t="1670464856041"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2927"
                      width="15"
                      height="15"
                    >
                      <path d="M940.8 160L396.8 704 83.2 384 0 467.2l313.6 313.6 83.2 83.2L1024 243.2z" fill="#00b0dc" p-id="2928" />
                    </svg>
                    <div class="more-text">
                      {{ moreItem }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>
      <div id="customer-stories" class="customer-stories">
        <div class="customer-stories-content">
          <div class="title">近3000家企业选择我们</div>
          <div class="customer-stories-list">
            <div
              v-for="(item, index) in enterpriseList"
              :key="index"
              class="cystiner-stirues-item"
            >
              <img :src="item" alt="" />
            </div>
          </div>
          <div class="customer-stories-btn" @click="moreEnterprise">
            <div class="btn-text">查看更多案例</div>
          </div>
        </div>
      </div>
    </div> -->
    <div v-if="expertIndex != null" class="introduce-bealter">
      <div class="bag" @click="close"></div>
      <div :key="expertIndex" class="introduct-wrap">
        <div class="close" @click="close">
          <svg
            t="1668155870681"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2131"
            width="30"
            height="30"
          >
            <path d="M511.333 127.333c51.868 0 102.15 10.144 149.451 30.15 45.719 19.337 86.792 47.034 122.078 82.321 35.287 35.286 62.983 76.359 82.321 122.078 20.006 47.3 30.15 97.583 30.15 149.451s-10.144 102.15-30.15 149.451c-19.337 45.719-47.034 86.792-82.321 122.078-35.286 35.287-76.359 62.983-122.078 82.321-47.3 20.006-97.583 30.15-149.451 30.15s-102.15-10.144-149.451-30.15c-45.719-19.337-86.792-47.034-122.078-82.321-35.287-35.286-62.983-76.359-82.321-122.078-20.006-47.3-30.15-97.583-30.15-149.451s10.144-102.15 30.15-149.451c19.337-45.719 47.034-86.792 82.321-122.078 35.286-35.287 76.359-62.983 122.078-82.321 47.301-20.006 97.583-30.15 149.451-30.15m0-64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448z" fill="#757e8d" p-id="2132" />
            <path d="M557.254 512l147.373-147.373c12.497-12.497 12.497-32.758 0-45.255-12.496-12.497-32.758-12.497-45.254 0L512 466.746 364.627 319.373c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255L466.746 512 319.373 659.373c-12.497 12.496-12.497 32.758 0 45.254C325.621 710.876 333.811 714 342 714s16.379-3.124 22.627-9.373L512 557.254l147.373 147.373C665.621 710.876 673.811 714 682 714s16.379-3.124 22.627-9.373c12.497-12.496 12.497-32.758 0-45.254L557.254 512z" fill="#757e8d" p-id="2133" />
          </svg>
        </div>
        <div class="portrait-box">
          <img :src="expertList[expertIndex].portrait" alt="" class="img"/>
        </div>
        <div class="introduct-content">
          <div class="top-wrap">
            <div class="introduct-name">
              {{ expertList[expertIndex].name }}
            </div>
            <div class="introduct-position">
              {{ expertList[expertIndex].position }}
            </div>
          </div>
          <div class="expert-introduce">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide class="text">
                <div class="expert-title-list" v-html="expertList[expertIndex].title"></div>
              </swiper-slide>
              <div slot="scrollbar" class="swiper-scrollbar"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';
import stories1 from '@/assets/personnelrecruit/customer-stories1.png';
import stories2 from '@/assets/personnelrecruit/customer-stories2.png';
import stories3 from '@/assets/personnelrecruit/customer-stories3.png';
import stories4 from '@/assets/personnelrecruit/customer-stories4.png';
import stories5 from '@/assets/personnelrecruit/customer-stories5.png';
import stories6 from '@/assets/personnelrecruit/customer-stories6.png';
import stories7 from '@/assets/personnelrecruit/customer-stories7.png';
export default {
  name: 'BusinessSchool',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      expertTitle: '',
      expertDescribe: '',
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          draggable: true,
          el: '.swiper-scrollbar',
        },
        simulateTouch: false,
        mousewheel: true,
      },
      expertIndex: null,
      expertList: [
        // {
        //   portrait: '',
        //   name: '黄炳坚',
        //   position: '专家讲师',
        //   title: [
        //     '潜能开发及组织绩效提升推广师',
        //     '江门圆点企业管理顾问有限公司总经理',
        //     '国家一级人力资源管理师',
        //     '江门市人力资源经理协会特约专家讲师',
        //     '美国柯维《高效能人士七个习惯》行动推广师',
        //     '香港专业效能管理学院NLP身心提升推动师',
        //     '拓普理德卓越力领导力训练策动师',
        //     '美国博恩.崔士效能提升推广者与传播者',
        //     '近40年的教学育人及企业培训管理实践经验，对企业战略绩效管理体系中流程管理机制的绩效制定与流程执行、人才精英培育方面有独到之处，,是一位既具理论功底又具丰富企业实践的顾问型人力资源专家。',
        //     '擅于绩效管理的咨询与培训',
        //   ],
        // },
      ],
      expertColumnId: '',
      page: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      personnelTitle: '',
      personnelDescribe: '',
      personnelIndex: 0,
      personnelList: [],
      personnelTime: null,
      majorList: [
        {
          icon: require('@/assets/about/business/major1.png'),
          text: '中高端人才猎聘',
        },
        {
          icon: require('@/assets/about/business/major2.png'),
          text: '招聘外包',
        },
        {
          icon: require('@/assets/about/business/major3.png'),
          text: '招聘优化',
        },
        {
          icon: require('@/assets/about/business/major4.png'),
          text: '人力资源集成管理',
        },
        {
          icon: require('@/assets/about/business/major5.png'),
          text: '中高端人才网络招聘',
        },
        {
          icon: require('@/assets/about/business/major6.png'),
          text: '职业测评服务',
        },
      ],
      typeList: [
        {
          part: [
            {
              icon: require('@/assets/about/business/icon/type-icon1.png'),
              text: '程序员',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon2.png'),
              text: '网络管理员',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon3.png'),
              text: '多媒体应用制作技术员',
            },
          ],
          more: [
            '电子商务技术员',
            '信息系统运行管理员',
            '网页制作员',
            '信息处理技术员',
          ],
        },
        {
          part: [
            {
              icon: require('@/assets/about/business/icon/type-icon4.png'),
              text: '软件测评师',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon5.png'),
              text: '软件设计师',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon6.png'),
              text: '网络工程师',
            },
          ],
          more: [
            '软件过程能力评估师',
            '多媒体应用设计师',
            '嵌入式系统设计师',
            '计算机辅助算计师',
            '电子商务设计师',
            '信息安全工程师',
            '网页制作员',
            '信息处理技术员',
          ],
        },
        {
          part: [
            {
              icon: require('@/assets/about/business/icon/type-icon7.png'),
              text: '信息系统项目管理师',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon8.png'),
              text: '系统分析师',
            },
            {
              icon: require('@/assets/about/business/icon/type-icon9.png'),
              text: '系统架构设计师',
            },
          ],
          more: [
            '网络规划设计师',
            '系统规划与管理师',
          ],
        },
      ],
      enterpriseList: [
        stories1,
        stories2,
        stories3,
        stories4,
        stories5,
        stories6,
        stories7,
        stories1,
        stories2,
        stories3,
        stories4,
        stories5,
        stories6,
        stories7,
      ],
    };
  },
  mounted() {
    this.getPageColumn();
  },
  methods: {
    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1608278294938214400', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '专家团队') {
            this.expertColumnId = result[i].id
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var describe = rrsult.elements.find(obj => obj.name === 'describe').content;
              this.expertTitle = rrsult.name;
              this.expertDescribe = describe;
            });
            this.getExpertList();
            // const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            // getContentList(data).then(async (rrs) => {
            //   const rrsult = rrs.result;
            //   for (var j = 0; j < rrsult.data.length; j++) {
            //     const rts = await getContentDetail(rrsult.data[j].id);
            //     const rtsult = rts.result;
            //     const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
            //     var expert = {
            //       portrait: rrsult.data[j].icon,
            //       name: rrsult.data[j].title,
            //       position: rrsult.data[j].summaryTitle,
            //       title: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
            //     };
            //     this.expertList.push(expert);
            //   }
            // });
          } else if (result[i].name === '优质人才') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var describe = rrsult.elements.find(obj => obj.name === 'describe').content;
              this.personnelTitle = rrsult.name;
              this.personnelDescribe = describe;
            });
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
                // var expert = {
                //   portrait: rrsult.data[j].icon,
                //   name: rrsult.data[j].title,
                //   position: rrsult.data[j].summaryTitle,
                //   title: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
                // };
                var personne = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
                this.personnelList.push(personne);
              }
              this.personnelTiming();
            });
          }
        }
      });
    },
    async getExpertList() {
      var params = { columnId: this.expertColumnId, pageNum: this.page.pageNum, pageSize: this.page.pageSize, };
      var rrs = await getContentList(params);
      var rrsult = rrs.result;
      for (var j = 0; j < rrsult.data.length; j++) {
        const rts = await getContentDetail(rrsult.data[j].id);
        const rtsult = rts.result;
        const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
        var expert = {
          portrait: rrsult.data[j].icon,
          name: rrsult.data[j].title,
          position: rrsult.data[j].summaryTitle,
          title: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
        };
        this.expertList.push(expert);
      }
    },
    // prev() {
    //   if (this.expertIndex > 0) {
    //     this.expertIndex--;
    //   }
    // },
    // nest() {
    //   if (this.expertIndex < this.expertList.length - 1) {
    //     this.expertIndex++;
    //   }
    // },
    viewDetails(index) {
      this.expertIndex = index
    },
    close() {
      this.expertIndex = null
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getExpertList()
    },
    personnelTiming() {
      this.personnelTime = setInterval(() => {
        if (this.personnelIndex < this.personnelList.length - 1) {
          this.personnelIndex++;
        }else{
          this.personnelIndex = 0
        }
      }, 5000)
    },
    personnelPrev() {
      clearInterval(this.personnelTime)
      if (this.personnelIndex > 0) {
        this.personnelIndex--;
      }else{
        this.personnelIndex = this.personnelList.length - 1
        this.personnelTiming()
      }
    },
    personnelNest() {
      clearInterval(this.personnelTime)
      if (this.personnelIndex < this.personnelList.length - 1) {
        this.personnelIndex++;
      }else{
        this.personnelIndex = 0
        this.personnelTiming()
      }
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
  },
};
</script>

<style lang="less">
.expert-title-list{
  ul{
    width: 100%;
    li{
      background-color: transparent !important;
      margin-bottom: 5px !important;
      line-height: 24px;
      >span {
        background-color: transparent !important;
        background-color: #6e7889;
        font-family: OPPOSans-R;
        font-size: 14px;
      }
    }
  }
}
.wrap-item{
    img{
      width: auto;
      height: 100%;
      display: block;
    }
}
</style>
<style lang="less" scoped>
.business-school {
  width: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .expert-team {
    width: 100%;
    // height: 520px;
    min-width: var(--minwidth);
    // background: url("@/assets/about/business/expert-back.png") no-repeat;
    background-size: cover;
    background-position: center;
    margin-bottom: 16px;
    .expert-content {
      width: 1200px;
      height: 100%;
      padding-top: 70px;
      margin: 0 auto;
      box-sizing: border-box;
      .title {
        font-size: 32px;
        font-family: OPPOSans-M;
        color: #21252b;
        line-height: 1;
        margin-bottom: 20px;
        text-align: center;
      }
      .describe {
        width: 625px;
        font-size: 16px;
        font-family: OPPOSans-R;
        color: #5c6066;
        line-height: 26px;
        text-align: center;
        margin: 0 auto;
        margin-bottom: 65px;
      }
      .expert-wrap {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-self: flex-start;
        .expert-item{
          width: 256px;
          height: 400px;
          margin-right: calc((100% - 256px * 4) / 3);
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          .expert-portrait{
            width: 100%;
            height: 275px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            overflow: hidden;
            .portrait-img{
              width: 100%;
              height: auto;
              display: block;
            }
          }
          .expert-txt{
            width: 150px;
            padding-top: 23px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .expert-name{
              font-family: OPPOSans-R;
              font-size: 18px;
              color: #21252b;
              margin-bottom: 15px;
            }
            .expert-position{
              font-family: OPPOSans-R;
              font-size: 14px;
              color: #5c6066;
            }
          }
          &:nth-child(4n) {
            margin-right: 0;
          }
          &:hover{
            .expert-txt{
              padding-top: 15px;
            }
          }
        }
      }
      .pagination{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        ::v-deep .el-pagination{
          .btn-prev{
            width: 32px;
            height: 32px;
            background-color: #f5f5f5;
            border-radius: 4px;
            border: 1px solid #dfdfdf;
          }
          .el-pager{
            li{
              width: 32px;
              height: 32px;
              background-color: #fff;
              border-radius: 4px;
              border: 1px solid #dfdfdf;
            }
            .active{
              background-color: #00b0dc;
            }
          }
          .btn-next{
            width: 32px;
            height: 32px;
            background-color: #f5f5f5;
            border-radius: 4px;
            border: 1px solid #dfdfdf;
          }
        }
      }
      // .expert-wrap {
      //   width: 100%;
      //   height: 390px;
      //   box-shadow: 0px 2px 35px 0px rgba(136, 149, 182, 0.24);
      //   background: url("@/assets/about/business/expert.png") no-repeat;
      //   background-size: cover;
      //   background-position: center;
      //   border-radius: 12px;
      //   overflow: hidden;
      //   position: relative;
      //   .expert {
      //     width: 100%;
      //     height: 100%;
      //     display: flex;
      //     position: relative;
      //     z-index: 0;
      //     .expert-portrait {
      //       width: 450px;
      //       height: 100%;
      //       display: flex;
      //       justify-content: center;
      //       align-items: center;
      //       img {
      //         width: auto;
      //         height: 100%;
      //         display: block;
      //       }
      //     }
      //     .expert-introduce {
      //       flex: 1;
      //       margin: 60px 0 50px 60px;
      //       box-sizing: border-box;
      //       .swiper {
      //         height: 100%;
      //         .swiper-slide {
      //           &.text {
      //             height: auto;
      //             -webkit-box-sizing: border-box;
      //             box-sizing: border-box;
      //             padding-right: 10px;
      //           }
      //           .expert-name{
      //             font-family: OPPOSans-M;
      //             font-size: 34px;
      //             color: #21252b;
      //             line-height: 1;
      //             margin-bottom: 20px;
      //           }
      //           .expert-position{
      //             font-family: OPPOSans-R;
      //             font-size: 24px;
      //             color: #21252b;
      //             line-height: 1;
      //             margin-bottom: 35px;
      //           }
      //           .expert-title-list{
      //             width: 400px;
      //             font-family: OPPOSans-R;
      //             font-size: 16px;
      //             color: #5c6066;
      //             .title-item{
      //               margin-bottom: 5px;
      //               line-height: 24px;
      //             }
      //           }
      //         }
      //         .swiper-scrollbar{
      //           background-color: transparent;
      //           ::v-deep .swiper-scrollbar-drag{
      //             background: #cccccc;
      //           }
      //         }
      //       }
      //     }
      //   }
      //   .expert-transition-enter-active{
      //     animation: expert-in 0.3s;
      //   }
      //   .expert-transition-leave-active{
      //     animation: expert-in 0 reverse;
      //   }
      //   @keyframes expert-in {
      //     0% {
      //       opacity: 0;
      //     }
      //     100% {
      //       opacity: 1;
      //     }
      //   }
      //   .switch-button{
      //       position: absolute;
      //       bottom: 50px;
      //       right: 80px;
      //       width: 64px;
      //       height: 32px;
      //       border: 1px solid #f0f4fa;
      //       background-color: #fff;
      //       display: flex;
      //       z-index: 1;
      //       .button{
      //           width: 32px;
      //           height: 32px;
      //           display: flex;
      //           justify-content: center;
      //           align-items: center;
      //           cursor: pointer;
      //           .button-icon{
      //             width: 7px;
      //             height: auto;
      //             display: block;
      //           }
      //           .noNext{
      //               opacity: 0.5;
      //               cursor: initial;
      //           }
      //       }
      //       .nest-button{
      //           border-left: 1px solid #f0f4fa;
      //           box-sizing: border-box;
      //       }
      //   }
      // }
    }
  }
  .personnel{
    width: 100%;
    padding-top: 118px;
    background: url("@/assets/about/business/personnel-back.png") no-repeat;
    background-size: cover;
    background-position: center;
    .content{
      width: 828px;
      padding-top: 90px;
      padding-bottom: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .title{
        font-family: OPPOSans-M;
        font-size: 32px;
        color: #21252b;
        line-height: 1;
        margin-bottom: 15px;
        text-align: center;
      }
      .describe{
        width: 770px;
        font-size: 16px;
        font-family: OPPOSans-R;
        line-height: 26px;
        color: #5c6066;
        text-align: center;
        margin-bottom: 65px;
      }
      .content-wrap{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .wrap-left{
            flex: 1;
            position: relative;
            .wrap-item{
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                overflow: hidden;
            }
            .wrap-transition-enter-active{
              animation: wrap-in 0.5s;
            }
            .wrap-transition-leave-active{
              animation: wrap-in 0.5s reverse;
            }
            @keyframes wrap-in {
              0% {
                opacity: 0;
              }
              100% {
                opacity: 1;
              }
            }
        }
        .wrap-right{
          width: 220px;
          margin-left: 68px;
          .major-list{
            width: 100%;
            margin-bottom: 86px;
            .major-item{
              width: 220px;
              height: 52px;
              border-radius: 26px;
              background-color: #edf3f5;
              margin-bottom: 20px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding: 4px;
              box-sizing: border-box;
              .major-icon{
                width: 44px;
                height: 44px;
                background-color: #fff;
                border-radius: 50%;
                box-shadow: 0px 1px 4px 0px rgba(174, 179, 186, 0.27);
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                .icon{
                    display: block;
                }
              }
              .major-text{
                font-size: 16px;
                font-family: OPPOSans-M;
                color: #2f4873;
              }
            }
          }
          .switch-wrap{
            height: 48px;
            display: flex;
            align-items: center;
            .button{
                width: 48px;
                height: 48px;
                background-color: #fff;
                border-radius: 50%;
                margin-right: 16px;
                cursor: pointer;
            }
            .prev{
                background: url('@/assets/about/business/personnel-prev.png');
            }
            .nest{
                background: url('@/assets/about/business/personnel-nest.png');
            }
          }
        }
      }
    }
  }
  .research-wrap{
    width: 1200px;
    margin: 57px auto 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .title{
        font-size: 32px;
        font-family: OPPOSans-M;
        color: #21252b;
        line-height: 1;
        margin-bottom: 25px;
        margin-top: 32px;
    }
    .describe{
        font-family: OPPOSans-R;
        font-size: 16px;
        color: #5c6066;
        line-height: 1;
        margin-bottom: 60px;
    }
    .research-content{
        width: 1008px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .content-bottom{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .type-list{
            width: 280px;
            .type-item{
              width: 100%;
              height: 48px;
              border: 4px solid #fff;
              border-radius: 24px;
              box-sizing: border-box;
              margin-bottom: 20px;
              padding-left: 16px;
              box-shadow: 0px 1px 4px 0px  rgba(174, 179, 186, 0.2);
              display: flex;
              justify-content: flex-start;
              align-items: center;
              position: relative;
              .type-icon{
                display: block;
                margin-right: 9px;
              }
              .type-text{
                font-family: OPPOSans-R;
                font-size: 16px;
                color: #fff;
              }
              .more-wrap{
                width: 420px;
                height: 318px;
                background: #fff;
                border-top: 4px solid #85d8ff;
                box-shadow: 0px 2px 12px 0px rgba(180, 180, 180, 0.44);
                padding: 0 30px;
                display: none;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                position: absolute;
                left: 0;
                top: 53px;
                box-sizing: border-box;
                z-index: 3;
                .more-top{
                  width: 100%;
                  padding-bottom: 19px;
                  border-bottom: 1px solid #ebe8e8;
                  .top-title{
                    font-family: OPPOSans-M;
                    font-size: 18px;
                    color: #181818;
                    line-height: 1;
                    margin-top: 47px;
                  }
                }
                .more-content{
                  width: 100%;
                  height: 230px;
                  padding-bottom: 50px;
                  box-sizing: border-box;
                  display: flex;
                  flex-direction: column;
                  flex-wrap: wrap;
                  justify-content: flex-start;
                  align-items: flex-start;
                  .more-item{
                    width: 50%;
                    margin-top: 30px;
                    display: flex;
                    align-items: center;
                    .more-text{
                      margin-left: 12px;
                      font-size: 14px;
                      font-family: OPPOSans-R;
                      line-height: 1;
                      color: #181818;
                    }
                  }
                }
              }
            }
            .more{
              &:hover{
                >.more-wrap{
                  display: flex;
                }
              }
            }
            &:nth-child(1){
                .type-item{
                    background-image: linear-gradient(90deg,#6bd0ff 0%,#9ee0ff 100%);
                }
            }
            &:nth-child(2){
                .type-item{
                    background-image: linear-gradient(90deg,#6ba2ff 0%,#9fceff 100%);
                }
            }
            &:nth-child(3 ){
                .type-item{
                    background-image: linear-gradient(90deg,#6b72ff 0%,#9ea3ff 100%);
                }
            }
          }
        }
    }
  }
  .introduce-bealter{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    .bag{
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }
    .introduct-wrap{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;
      display: flex;
      background-color: #fff;
      width: 1000px;
      height: 390px;
      border-radius: 4px;
      padding: 40px 60px 40px 40px;
      box-sizing: border-box;
      .close {
        width: 30px;
        height: 30px;
        position: absolute;
        right: 35px;
        top: 35px;
        cursor: pointer;
        z-index: 9999;
      }
      .portrait-box{
        width: 288px;
        height: 310px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
        .img{
          width: 100%;
          height: auto;
        }
      }
      .introduct-content{
        width: 542px;
        margin-left: 70px;
        display: flex;
        flex-direction: column;
        .top-wrap{
          border-bottom: 1px solid #d2d9e3;
          margin-bottom: 20px;
          .introduct-name{
            font-family: OPPOSans-R;
            font-size: 18px;
            color: #21252b;
            margin-bottom: 14px;
          }
          .introduct-position{
            font-family: OPPOSans-R;
            font-size: 14px;
            color: #5c6066;
            margin-bottom: 14px;
          }
        }
        .expert-introduce{
          flex: 1;
          box-sizing: border-box;
          overflow: hidden;
          .swiper{
            height: 100%;
            .swiper-slide{
              &.text{
                height: auto;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding-right: 10px;
              }
              .expert-title-list{
                width: 400px;
                font-family: OPPOSans-R;
                font-size: 16px;
                color: #5c6066;
                .title-item{
                  margin-bottom: 5px;
                  line-height: 24px;
                }
              }
            }
            .swiper-scrollbar{
              background-color: transparent;
              ::v-deep .swiper-scrollbar-drag{
                background: #cccccc;
              }
            }
          }
        }
      }
    }
  }
  // .customer-stories {
  //     display: flex;
  //     flex-direction: column;
  //     padding: 0 0 60px;
  //     box-sizing: border-box;

  //     .customer-stories-content {
  //       width: 1200px;
  //       // min-width: var(--minwidth);
  //       margin: 0 auto;
  //       display: flex;
  //       flex-direction: column;
  //       align-items: center;
  //       .title {
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         font-size: 16px;
  //         font-weight: 500;
  //         color: #59697d;
  //         margin-bottom: 64px;
  //         position: relative;
  //       }
  //       .title::before {
  //         position: absolute;
  //         left: -516px;
  //         content: '';
  //         width: 494px;
  //         height: 1px;
  //         background-color: #c0c0c0;
  //       }
  //       .title::after {
  //         position: absolute;
  //         right: -516px;
  //         content: '';
  //         width: 494px;
  //         height: 1px;
  //         background-color: #c0c0c0;
  //       }
  //       .customer-stories-list {
  //         width: 100%;
  //         display: flex;
  //         flex-wrap: wrap;
  //         justify-content: flex-start;
  //         .cystiner-stirues-item {
  //           width: calc(14.285% - 56px);
  //           height: 36px;
  //           margin: 27px;
  //           background-color: #fff;
  //           display: flex;
  //           justify-content: center;
  //           align-items: center;
  //         }
  //       }
  //       .customer-stories-btn {
  //         width: 124px;
  //         height: 42px;
  //         background-color: #2979ff;
  //         border-radius: 8px;
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         margin-top: 30px;
  //         cursor: pointer;
  //         position: relative;
  //         .btn-text {
  //           font-size: 15px;
  //           color: #ffffff;
  //         }
  //       }
  //       .customer-stories-btn::before {
  //         position: absolute;
  //         left: -538px;
  //         content: '';
  //         width: 494px;
  //         height: 1px;
  //         background-color: #c0c0c0;
  //       }
  //       .customer-stories-btn::after {
  //         position: absolute;
  //         right: -538px;
  //         content: '';
  //         width: 494px;
  //         height: 1px;
  //         background-color: #c0c0c0;
  //       }
  //     }
  //   }
}
</style>
